import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-chat-bot-button',
  template: `
    <img class="avatar" src="/images/chat-bot/bot.png">
    <button class="button">{{ 'chatBot.banner.cta' | translate }}</button>
  `,
  styleUrls: ['./chat-bot-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatBotButtonComponent {}



// WEBPACK FOOTER //
// ./ts/app/header/chat-bot-button/chat-bot-button.component.ts